
import React,{useEffect,useState,useRef,useContext} from "react";
import { Spin, Form, Col, Button, Row,message,Space,Table,Input,DatePicker,Popconfirm,InputNumber} from 'antd';
import queryString from 'query-string';
import history from "../../history";
import getEbBasvuruOzellikByMultiRowT from "../../services/getEbBasvuruOzellikByMultiRowT";
import MultiRowTable from "../Helpers/MultiRowTable";
import setEbBasvuruOzellik from "../../services/setEbBasvuruOzellik";
import { isNullOrEmptyOrUndefined,errorMessage, successMessage } from "../Helpers/Util";
import { kodEbEditorType, kodEbTypeCode } from "../Helpers/Enum";
import moment from "moment";
import trLocale from "../Helpers/trLocale";

const parsed = queryString.parse(history.location.search);


const formLayout = {
    labelCol : {
        span : 6
    },
    wrapperCol : {
        span : 12
    }
}

const BasvuruOzellikByMultiRowT = () => {

    const EditableContext = React.createContext(null);
    const [spining, setSpining] = useState(false);
    const inputRef = useRef(null);
    const [dynamicColumns, setDynamicColumns] = useState([]);
    const [dataSources, setDataSources] = useState([]);
    const [count, setCount] = useState();
    const [basvuruOzellik, setBasvuruOzellik] = useState([]);

    const [form] = Form.useForm();

    const handleSave = (row) => {
        const newData = [...dataSources];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        setDataSources(newData);
    };  
    
    const onLoad = async() => {

        setSpining(true);
        await getEbBasvuruOzellikByMultiRowT(parsed).then(resp => {           
            if(resp.data.success){
                setDataSources(resp.data.result.DataSources);
                setCount(resp.data.result.GrupKodu);
                setBasvuruOzellik(resp.data.result.OzellikList);
                setDynamicColumns(resp.data.result.Columns);
                                     
            }else{                
                message.error(resp.data.message);
            }
        }).catch(ex => {
            message.error(String(ex.message));
        });

        setSpining(false);
 
    }

    const defaultColumns = ([...dynamicColumns, {
      title: 'Sil',
      dataIndex: 'delete',
      render: (_, record) =>
       
          <Popconfirm title="Emin Misiniz?" onConfirm={() => handleDelete(record.key)}>
            <a>Sil</a>
          </Popconfirm>
        
    }]);

    const columns = defaultColumns.map((col) => {
        if (!col.editable) {
          return col;
        }
        return {
          ...col,
          onCell: (record) => ({
            record,
            editable: col.editable,
            dataIndex: col.dataIndex,
            title: col.title,
            handleSave,
          }),
        };
      });  

    const addRowInfInRuhsat = () => {
      var addRowData = {
        key: (String)(count + 1)
      };

      basvuruOzellik.map(resp => {
        addRowData[resp.Adi] = ""
      });

      setCount(count + 1);
      setDataSources([...dataSources, addRowData]);
        
     };

     const handleDelete = (key) => {

      const data = dataSources.filter((item) => item.key == key);
      if(data.length != 0){
        const newData = dataSources.filter((item) => item.key !== key);
        setDataSources(newData);
      }
     
    };
    
    useEffect(() => {
        onLoad();
    },[]);

   
    const EditableRow = ({ index, ...props }) => {
        const [form] = Form.useForm();
        return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
            <tr {...props} />
            </EditableContext.Provider>
        </Form>
        );
    };

    const GetBasvuruOZellikByAdi = (adi) => {
      var ozellik = basvuruOzellik.filter(k => k.Adi == adi)[0];
      return ozellik;
    }

    
    const EditableCell = ({
        title,
        editable,
        children,
        dataIndex,
        record,
        handleSave,
        ...restProps
      }) => {
        var ozellik = GetBasvuruOZellikByAdi(dataIndex);

        const [editing, setEditing] = useState(false);
        
        const form = useContext(EditableContext);
      
        useEffect(() => {
          if (editing) {
            inputRef.current.focus();
          }
        }, [editing]);
      
        const toggleEdit = () => {
          setEditing(!editing);
          if(ozellik.Editortipi == kodEbEditorType.DateTimeTag  &&  !isNullOrEmptyOrUndefined(record[dataIndex]))
            form.setFieldsValue({ [dataIndex]: moment(record[dataIndex]) });
          else
            form.setFieldsValue({ [dataIndex]: record[dataIndex] });
        };

        const GetFormItemLabel = (item) => {
          switch(item.Editortipi) {
            case kodEbEditorType.DateTimeTag :  
              return (                  
                <DatePicker
                    ref={inputRef} 
                    locale={trLocale}
                    format={"YYYY-MM-DD"}
                    style={{width : '95%'}}
                    onChange={(__,val) => {saveDate(val)}}
                    
                />    
              ); 
              case  kodEbEditorType.InputNumberTag :
                return (
                  <InputNumber  ref={inputRef}
                                onPressEnter={save} 
                                onBlur={save}
                                style={{width : '95%'}}
                               
                            />
                );
    
              case kodEbEditorType.InputTag :  
              default :
                return <Input onPressEnter={save} onBlur={save} ref={inputRef}  /> ; 
          }
        }
    
        const saveDate = async (values) => {
          try {
            const val = await form.validateFields();
            Object.keys(val).map(key => {
              val[key] = values;
            });
            toggleEdit();
            handleSave({ ...record, ...val });
          } catch (errInfo) {
            console.log('Save failed:', errInfo);
          }
        };

        const save = async (val) => {
          try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({ ...record, ...values });
          } catch (errInfo) {
            console.log('Save failed:', errInfo);
          }
        };
      
        let childNode = children;
      
        if (editable) {
          childNode = editing ? (
            <Form.Item
              style={{ margin: 0 }}
              name={dataIndex}
              rules={[
                {
                  required: true,
                  message: `${title} zorunludur.`,
                },
              ]}
            >
              {GetFormItemLabel(ozellik)}
              
            </Form.Item>
          ) : (
            <div className="editable-cell-value-wrap" style={{ paddingRight: 24 }} onClick={toggleEdit}>
              {children}
            </div>
          );
        }
      
        return <td {...restProps}>{childNode}</td>;
      };

    const components = {
        body: {
          row: EditableRow,
          cell: EditableCell,
        },
      };

    const getDataFilter= (key,grupKodu,ozellikDeger) => {
      var data = {         
          OzellikKodu: key,
          OzellikDeger: [ozellikDeger],
          GrupKodu : grupKodu,
          ZorunluMu : true
      };


      return data;
  }

    const onFinish = async(e) => {
      setSpining(true);
        var result = true;
        var message = "";
        dataSources.map(resp => {
          Object.keys(resp).forEach(function(key) {
            if(isNullOrEmptyOrUndefined(resp[key])){
              result = false;
              message = "Lütfen bilgileri doldurunuz!";
            }
          });         
        });
        
        if(!result){
          errorMessage(message);
          setSpining(false);
        }else{
          
          let dataFilter = {
              TabloAdi: parsed.TabloAdi,
              KodOzellikList : basvuruOzellik,
              EbBasvuruOzellik : []
          };

          if(parsed.TabloAdi == 'basvuru') {
            dataFilter.TabloObjectid = parseInt(parsed.BasvuruId)
          }else if (parsed.TabloAdi == 'basvuru_ana'){
              dataFilter.TabloObjectid = parseInt(parsed.ParentBasvuruId)
          }


          await dataSources.map(sources => {
            Object.keys(sources).map(key => {
              var ozellik = GetBasvuruOZellikByAdi(key);
              if(ozellik != null){
                var data = getDataFilter(ozellik.Objectid,sources['key'],sources[key]);
                dataFilter.EbBasvuruOzellik.push(data);
              }
                
            })
           
          });
          
            await setEbBasvuruOzellik(dataFilter).then(resp => {
            
                if(resp.data.success){
                    successMessage('İşlem başarı ile tamamlandı.');               
                    window.parent.location.reload(); 
                }else{     
                           
                   errorMessage(resp.data.message);
                }
            }).catch(ex => {
                 errorMessage(String(ex.message));
            }).finally(() => {
                setSpining(false);
            });
            

        }
    }

    return(
        <Spin tip={"Veriler Yükleniyor"} spinning={spining} style={{width: '100%', justifyContent: 'center', marginTop : '20%'}} > 
        {basvuruOzellik.length != 0 ? 
                  <div style={{margin:30}}>
                    <Button onClick={addRowInfInRuhsat} type="primary" style={{ marginBottom: 16 }}>
                      Yeni Bilgi Ekle
                    </Button>
                    <Table
                      components={components}
                      rowClassName={() => 'editable-row'}
                      bordered
                      dataSource={dataSources}
                      columns={columns}
                    />                                             
                    
                    <div style={{ display: "flex" }}>
                      <Button style={{ marginLeft: "auto" }} type="primary" onClick={onFinish}>
                          Kaydet
                      </Button>
                     </div> 
                       
                  </div>
                  : 
              <>
                {!spining && <Space direction="horizontal" style={{width: '100%', justifyContent: 'center', marginTop : '20%', fontWeight:"bold"}}> Özellik Bulunamadı </Space>}
            </>
            }
            
        </Spin>
);
}

export default  BasvuruOzellikByMultiRowT;